<template>
    <st-divider-styled :class="clear && 'clear-both'" :between="between" :inline="inline" :position="position">
        <slot />
    </st-divider-styled>
</template>

<script>
import styled, { css } from "vue-styled-components";

const props = {
    between: {
        type: Number,
        default: () => 1
    },
    inline: Boolean,
    clear: Boolean,
    position: String
};

const StDividerStyled = styled("div", props)`
    margin-bottom: ${props => props.between * 1}rem;
    display: ${props => (props.inline ? "inline-block" : "block")};

    ${props =>
        props.position &&
        css`
            position: ${props.position};
        `}
`;

export default {
    name: "StDivider",
    props: {
        ...props
    },
    methods: {},
    components: {
        StDividerStyled
    }
};
</script>
